export const maxDelay = 2147483647;
//# sourceMappingURL=helpersConstants.js.map